import Container from '@/components/Container';
import useIsTablet from '@/hooks/useIsTablet';

export const PodcastListLoading = () => {
  const { isTablet } = useIsTablet();

  return (
    <>
      <div className="w-full bg-light-green py-sh-60">
        <Container>
          <div className="col-span-12">
            <div className="my-[12px]">
              <div className="h-8 w-48 animate-pulse rounded bg-gray-200" />
            </div>
            <div className="mt-sh-30 grid gap-sh-30 md:grid-cols-2 md:items-start">
              <div className="h-48 w-full animate-pulse rounded-lg bg-gray-200" />
              <div className="min-w-0">
                <div className="mb-[16px] h-8 w-3/4 animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
                <div className="mt-2 h-4 w-3/4 animate-pulse rounded bg-gray-200" />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Container className="min-h-40" addMargin={!isTablet}>
        <div className="col-span-12 mt-[36px] md:mt-[0px]">
          <div className="mb-sh-30">
            <div className="mb-sh-30 h-6 w-32 rounded bg-gray-200" />
            <div className="grid grid-cols-1 gap-sh-30 md:grid-cols-2 md:gap-4">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="h-[402px] animate-pulse rounded-2xl border border-gray-200 bg-gray-100" />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};
